"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DonationRebalanced = void 0;
var PreludeCard_1 = require("../../prelude/PreludeCard");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var DonationRebalanced = (function (_super) {
    __extends(DonationRebalanced, _super);
    function DonationRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.DONATION_REBALANCED,
            metadata: {
                cardNumber: 'P08',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(23);
                }),
                description: 'Gain 23 M€.',
            },
        }) || this;
    }
    DonationRebalanced.prototype.play = function (player) {
        player.megaCredits += 23;
        return undefined;
    };
    return DonationRebalanced;
}(PreludeCard_1.PreludeCard));
exports.DonationRebalanced = DonationRebalanced;
//# sourceMappingURL=DonationRebalanced.js.map